import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { SignInModel } from "./type";

const initialState: SignInModel = {
  phoneNo: "",
  email: "",
  isSignIn: false,
};

const SignInSlice = createSlice({
  name: "SignIn",
  initialState,
  reducers: {
    setUserPhoneNo: (state: SignInModel, action: PayloadAction<string>) => {
      state.phoneNo = action.payload;
    },

    setUserEmail: (state: SignInModel, action: PayloadAction<string>) => {
      state.email = action.payload;
    },

    setIsSignIn: (state: SignInModel, action: PayloadAction<boolean>) => {
      state.isSignIn = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserPhoneNo, setIsSignIn, setUserEmail } =
  SignInSlice.actions;

export default SignInSlice.reducer;
